<template>
  <div id="go-pay">
    <SfCallToAction v-e2e="'go-pay-banner'" class="banner xpayBanner" :title="title ? title + '：' : ''"
      style="background-color:#F2F1F6;background-size: contain;background-position: right;background-repeat: no-repeat !important;">
      <template #description>
        <VsfPaymentProvider :hidden="isCard" @status="backProvider" :checked="true" @initBack="ProviderInitBack" @thankyou='backXianXia' />
        <div class="banner__order-number" style="margin-bottom: 10px">
          <span>{{ $t('Order_No') }}:</span>
          <strong>{{ orderNumber }}</strong>
        </div>
        <div v-if="error" class="margintop">
          <SfAlert :message="error" type="danger" />
        </div>
        <div v-if="!isLoading && !error && !isCard">
          <img v-if="qrcode && payCodeVisable && payWayId + '' !== '-999'" :src="qrcode" alt="QR code" class="qrcode" />
          <div v-if="qrcode && !payCodeVisable">
            {{ $t('pay_code_shixiao') }}
            <SfButton @click="backProvider" class="sf-button--text margintop">
              {{ $t('pay_code_refresh') }}
            </SfButton>
          </div>
          <SfButton class="color-secondary button-size margintop" @click="goOrderList" v-if="isPay">
            {{ $t('go_order_history') }}</SfButton>
        </div>
        <div v-if="isLoading">
          <SfLoader :loading="true" class="loadingbox" />
        </div>
        <div>
          <IdCard v-show="isCard" ref="IdCardRef" style="margin-bottom: 1rem;" />
          <SfButton v-if="isCard" type="button" @click="upIdCard">
            {{ $t('save_and_pay') }}
          </SfButton>

          <SfButton v-if="credentialId" @click="shareOrder" class="sf-button--text margintop">
            {{ $t('zhuanfa_toBePay') }}
          </SfButton>
        </div>
      </template>
    </SfCallToAction>
  </div>
</template>

<script>
import SfCallToAction from '@/components/SfCallToAction';
import { SfHeading, SfButton, SfLoader, SfAlert } from '@storefront-ui/vue';
import { ref, watch, onBeforeUnmount, onUnmounted, onMounted } from '@nuxtjs/composition-api';
import { addBasePath, onSSR } from '@vue-storefront/core';
import { computed, useRoute } from '@nuxtjs/composition-api';
import { usePay, useApiError, usePayerUpdate, useOCart } from '@bee-hole/coms';
import { useOrder } from '~/composables';
import { usePreviewOrderStore } from '~/stores/previewOrder';
import IdCard from '~/components/Checkout/IdCard';
import { useUiState } from "~/composables";
export default {
  components: {
    SfHeading,
    SfButton,
    SfCallToAction,
    SfLoader,
    SfAlert,
    VsfPaymentProvider: () => import('~/components/Checkout/VsfPaymentProvider'),
    IdCard
  },
  layout({ app }) {
    return 'default';
  },
  setup(props, { root }) {
    const {
      isMobile
    } = useUiState();
    const isLoading = ref(true);
    const route = useRoute();
    const { set: setError } = useApiError();
    const previewOrderStore = usePreviewOrderStore();
    const { load: loadCart } = useOCart();
    const { updateIdCard: update, error: IdCardErr } = usePayerUpdate();
    const orderNumber = ref(route.value.query.orderNumber);
    const credentialId = ref(route.value.query.credential_id);
    const payWayId = ref();
    const payMethod = ref(route.value.query.payWayId || 'wechatpay');
    const timer = ref(props.timer);
    const isCard = ref(previewOrderStore?.IdCard?.has_identity || false);
    const payCodeVisable = ref(true);
    const title = computed(() => {
      return root.$t(isCard.value ? '' : 'pleasePayType');
    });
    const IdCardRef = ref();
    const payTimer = ref(null);
    let baseUrl = '';
    if (process.client) {
      baseUrl = window.location.origin;
    }

    const backUrl = computed(() => {
      return baseUrl + root?.localePath(`/checkout/thank-you?orderNumber=${orderNumber.value}`);
    });
    const cancelUrl = computed(() => {
      return baseUrl + root?.localePath(`/xpay?orderNumber=${orderNumber.value}&credential_id=${credentialId.value}`);
    });
    // console.log('----支付回调地址-----', backUrl, (backUrl));

    const { load: loadOrder, isPayed } = useOrder(orderNumber.value);
    const goThankYou = (is_manual_payment) => {
      const transformedPath = { name: 'thank-you', query: { orderNumber: orderNumber.value } };
      if (is_manual_payment) {
        transformedPath.query.is_manual_payment = 1;
      }
      root.$router.push(root.localePath(transformedPath));
    };
    onMounted(async () => {
      const time = 2000;
      const userKey = root?.$cookies.get("userKey");
      await loadCart();
      if (userKey) {
        window.parent.postMessage({
          prepay_id: orderNumber.value,
          credential_id: credentialId.value
        }, '*');
      }
      if (isCard.value) {
        isLoading.value = false;
      }
      timer.value = setInterval(async () => {
        await loadOrder();
        isLoading.value = false;
        if (isPayed.value) {
          clearInterval(timer.value);
          // console.log('=======支付成功');
          previewOrderStore.clearIdCard();
          goThankYou();
        } else {
          // console.log('=======未支付');
        }
      }, time);
    });

    const { result, pay, loading, error } = usePay(orderNumber?.value, payMethod?.value);
    const qrcode = computed(() => {
      if (result?.value?.native?.qr_code_summary) {
        return 'data:image/jpeg;base64, ' + result?.value?.native?.qr_code_summary;
      }
    });
    //
    const celarTime = () => {
      clearInterval(timer.value);
      clearInterval(payTimer.value);
    };
    onUnmounted(() => {
      celarTime();
    });
    // 页面被卸载前
    onBeforeUnmount(() => {
      previewOrderStore.clearIdCard();
      celarTime();
    });
    // 发起支付结果
    watch(result, (r) => {
      const url64 = r?.jsapi?.auth_link;
      const h5Url = r?.h5?.h5_url;
      if (url64) {
        // 对url进行base64解码
        const url = Buffer.from(url64, 'base64').toString('binary');
        window.location.href = url;
      }
      if (h5Url) {
        window.location.href = h5Url;
      }
    });

    const goOrderList = () => {
      const transformedPath = '/my-account/History';
      root.$router.push(root.localePath(transformedPath));
    };
    const payOrder = async () => {
      await loadOrder();
      if (isPayed.value) {
        goThankYou();
        return;
      }
      if (String(previewOrderStore?.paymethod?.payWayId) === '-999') {
        // goThankYou();
        // celarTime();
        // const transformedPath = `/my-account/History` + '?open=2&pid=' + orderNumber.value;
        // const localeTransformedPath = root.localePath(transformedPath);
        // root.$router.push(localeTransformedPath);
        return false;
      }
      isLoading.value = true;
      let type = 'NATIVE';
      if (process.client) {
        type = /MicroMessenger/i.test(window.navigator.userAgent) ? 'JSAPI' : 'NATIVE';
        if (type === 'JSAPI') {
          if (!isMobile.value) {
            type = 'NATIVE';
          }
        }
        if (previewOrderStore?.paymethod?.enName === 'Alipay' || previewOrderStore?.paymethod?.enName === 'USEEPAY') {
          if (isMobile.value) {
            type = 'JSAPI';
          } else {
            type = 'H5';
          }
        }
      }
      const query = {
        scene_type: type,
        prepay_id: orderNumber.value,
        scene_info: {
          paid_return_url: (backUrl.value),
          cancel_return_url: (cancelUrl.value)
        },
        combine_pay: true,
        currency: previewOrderStore?.paymethodCurreny,
        pay_way_id: previewOrderStore?.paymethod?.payWayId,
        credential_id: credentialId.value
      };
      if (previewOrderStore?.order?.combined === 2) {
        query.combine_pay = true;
      }
      // console.log('支付下单入参:', query);
      // setError('支付下单入参:' + query);
      // 判断backUrl是否http开头
      if (backUrl.value.indexOf('http') === 0) {
        await pay(query);
        // console.info('准备支付:', query);
      } else {
        setError({ message: '支付回调地址不合法:' + backUrl.value, code: 50 });
      }
      isLoading.value = false;
    };
    onSSR(async () => {
    });
    // const isPayFc = async () => {
    //   if (isPayed.value) {
    //     clearInterval(payTimer.value);
    //     // console.log('=======支付成功');
    //   } else {
    //     payOrder();
    //     console.log('=======未支付 刷新支付码');
    //   }
    // };
    const backProvider = () => {
      payWayId.value = previewOrderStore?.paymethod?.payWayId;
      // js判断pc端每分钟执行一次
      clearInterval(payTimer.value);
      if (process.client && !isCard.value) {
        payOrder();
        payCodeVisable.value = true;
        if (!/MicroMessenger/i.test(window.navigator.userAgent)) {
          payTimer.value = setInterval(async () => {
            payCodeVisable.value = false;
          }, 1800 * 1000);
        }
      }
    };
    const upIdCard = async () => {
      const valid = IdCardRef.value?.checkedValid();
      if (valid) {
        await update({
          id_name: previewOrderStore.IdCard.id_name,
          id_number: previewOrderStore.IdCard.id_number,
          prepay_id: orderNumber.value
        });
        if (IdCardErr?.value?.load === null) {
          isCard.value = false;
          isLoading.value = false;
          backProvider();
        } else {
          setError({ code: 500, message: IdCardErr?.value?.load?.message });
        }
      }
    };
    const ProviderInitBack = () => {
      isCard.value = previewOrderStore?.IdCard?.has_identity;
      isLoading.value = false;
    };
    const shareOrder = () => {
      const input = document.createElement('input');
      input.setAttribute('readonly', 'readonly');
      const url = window.location.href;
      input.setAttribute('value', url);
      document.body.appendChild(input);
      input.select();
      if (document.execCommand('copy')) {
        document.execCommand('copy');
        setError({ code: 0, message: root.$t('linkCopied') });
      }
      document.body.removeChild(input);
    };
    const backXianXia = () =>{
      goThankYou(1);
    }
    return {
      timer,
      isLoading,
      error,
      qrcode,
      addBasePath,
      orderNumber,
      goOrderList,
      backProvider,
      isPay: computed(() => isPayed.value),
      credentialId,
      title,
      isCard,
      upIdCard,
      ProviderInitBack,
      shareOrder,
      payCodeVisable,
      IdCardRef,
      payWayId,
      backXianXia
    };
  }
};
</script>
<style lang="scss" scoped>
.loadingbox {
  div {
    justify-content: left;
  }

  margin-top: 20px;
}

.margintop {
  margin-top: 20px;
}

.qrcode {
  display: block;
  margin-top: 20px;
  width: 240px;
  height: 240px;
}

#go-pay {
  box-sizing: border-box;

  @include for-desktop {
    min-height: 600px;
    max-width: 1272px;
    padding: 0 var(--spacer-sm);
    margin: 0 auto;
  }
}

.heading {
  --heading-padding: var(--spacer-base) 0;

  @include for-desktop {
    --heading-padding: var(--spacer-sm) 0 var(--spacer-xs) 0;
  }
}

.paragraph {
  margin: 0;
  color: var(--c-link);
  font: var(--font-weight--normal) var(--font-size--base) / 1.6 var(--font-family--primary);

  @include for-desktop {
    font-weight: var(--font-weight--light);
    font-size: var(--font-size--sm);
    margin-bottom: var(--spacer-lg);
  }
}

.banner {
  --call-to-action-color: var(--c-text);
  --call-to-action-title-font-size: var(--h2-font-size);
  --call-to-action-title-font-weight: var(--font-weight--semibold);
  --call-to-action-text-container-width: 50%;
  background-position: center;

  @include for-mobile {
    --call-to-action-text-container-width: 100%;
  }

  @include for-desktop {
    margin: 0 0 var(--spacer-2xl) 0;
  }

  &__order-number {
    display: flex;
    flex-direction: column;
    font: var(--font-weight--light) var(--font-size--sm) / 1.4 var(--font-family--primary);

    @include for-desktop {
      flex-direction: row;
      font-size: var(--font-size--normal);
    }
  }
}

.section {
  display: flex;
  flex-direction: column;
  margin: 0 auto;

  @include for-desktop {
    flex-direction: row;
    padding: 0;
    background: var(--c-light);
  }
}

.order {
  background: var(--c-light);
  padding-bottom: var(--spacer-sm);

  @include for-desktop {
    width: 100%;
    padding: var(--spacer-xl) var(--spacer-xl) var(--spacer-2xl) var(--spacer-2xl);
  }

  &__heading {
    --heading-title-font-weight: var(--font-weight--bold);

    @include for-desktop {
      --heading-title-color: var(--c-link);
      --heading-title-font-weight: var(--font-weight--swemibold);
    }
  }

  &__heading,
  &__paragraph,
  &__contact {
    @include for-mobile {
      margin: 0;
      padding-left: var(--spacer-sm);
      padding-right: var(--spacer-sm);
    }
  }

  &__contact {
    padding-bottom: var(--spacer-base);
    --heading-title-font-size: var(--font-size--lg);
    --heading-title-font-weight: var(--font-weight--medium);

    @include for-desktop {
      --heading-title-font-size: var(--font-size--base);
      --heading-title-font-weight: var(--font-weight--normal);
      padding: 0 var(--spacer-sm);
      border: 2px solid var(--c-white);
      border-width: 2px 0 2px 0;
    }
  }

  &__notifications-button {
    --button-width: calc(100% - var(--spacer-lg));
    margin: 0 auto;

    @include for-desktop {
      margin: var(--spacer-xl) 0 0 0;
    }
  }
}

.contact {
  color: var(--c-dark-variant);
  font: var(--font-weight--light) var(--font-size--base) / 1.6 var(--font-family--secondary);

  @include for-desktop {
    font-weight: var(--font-weight--normal);
    font-size: var(--font-size--sm);
  }

  &__name,
  &__street,
  &__city {
    margin: 0;
  }

  &__email {
    margin: var(--spacer-sm) 0 0 0;

    @include for-desktop {
      margin-bottom: var(--spacer-sm);
    }
  }

  &__name,
  &__street,
  &__city,
  &__email {
    font-size: var(--font-size--sm);
  }
}

.additional-info {
  --heading-title-font-weight: var(--font-weight--bold);
  padding: 0 var(--spacer-sm);

  @include for-desktop {
    --heading-title-color: var(--c-link);
    --heading-title-font-weight: var(--font-weight--semibold);
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: var(--spacer-xl) var(--spacer-xl) var(--spacer-2xl) var(--spacer-2xl);
  }
}

.feedback-button {
  margin: var(--spacer-xl) 0 var(--spacer-sm) 0;

  @include for-desktop {
    margin: var(--spacer-base) 0 0 0;
  }
}

.back-button {
  --button-width: calc(100% - var(--spacer-lg));
  margin: 0 auto var(--spacer-sm) auto;

  @include for-desktop {
    margin: var(--spacer-xl) auto;
  }
}

.button-size {
  @include for-desktop {
    --button-width: 25rem;
  }
}
</style>
